import { render, staticRenderFns } from "./item-review.vue?vue&type=template&id=71e4a6cb&"
import script from "./item-review.vue?vue&type=script&lang=js&"
export * from "./item-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports